var PurchasePresenter = /** @class */ (function () {
    function PurchasePresenter(usecase, actions) {
        this.usecase = usecase;
        this.actions = actions;
    }
    PurchasePresenter.prototype.orders = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.orders.execute({
                onSuccess: function (data) {
                    _this.actions.updateOrders(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    PurchasePresenter.prototype.orderList = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.orderList.execute({
                onSuccess: function (data) {
                    _this.actions.updateOrderList(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    PurchasePresenter.prototype.empPartnerDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.empPartnerDetails.execute({
                onSuccess: function (data) {
                    if (req.searchfor === "P") {
                        _this.actions.updateEmpPartnerDetails(data);
                    }
                    else {
                        _this.actions.loginSearch(data);
                    }
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    PurchasePresenter.prototype.docs = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.docs.execute({
                onSuccess: function (data) {
                    _this.actions.updateDocs(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    PurchasePresenter.prototype.orderDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.orderDetails.execute({
                onSuccess: function (data) {
                    _this.actions.updateOrderDetails(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    PurchasePresenter.prototype.validateForm = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.validateForm.execute({
                onSuccess: function (data) {
                    if (data) {
                        resolve(data);
                        _this.actions.updateValidateForm(data);
                    }
                },
                onError: function (error) {
                    reject(error);
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                },
            }, req);
        });
    };
    PurchasePresenter.prototype.orderDeclarations = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.orderDeclarations.execute({
                onSuccess: function (data) {
                    _this.actions.updateOrderDeclarations(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    PurchasePresenter.prototype.updateSearchData = function (req) {
        this.actions.updateSelectedSearch(req);
    };
    PurchasePresenter.prototype.multidocs = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.multidocs.execute({
                onSuccess: function (data) {
                    _this.actions.multidocs(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    PurchasePresenter.prototype.updateOrders = function (response) {
        this.actions.updateOrders(response);
    };
    return PurchasePresenter;
}());
export default PurchasePresenter;
